// extracted by mini-css-extract-plugin
export default {"schedule_icon":"ScheduleIcon_schedule_icon__Q5ZNY","arrow_icon":"ScheduleIcon_arrow_icon__5zvyl"};